import Joi from 'joi';
import DpaData from './dictionary/dpa-data';
import DpaTransactionOptions from './dictionary/dpa-txn-options';

const InitModel = Joi.object()
  .keys({
    debug: Joi.boolean().optional(),
    dpaData: DpaData,
    dpaTransactionOptions: DpaTransactionOptions.optional(),
    isCypressMode: Joi.boolean().optional(),
    isProduction: Joi.boolean().optional(),
    srcInitiatorId: Joi.string().required(),
    srciDomain: Joi.string()
      .optional()
      .allow(''),
    srciDpaId: Joi.string().when('dpaData', {
      is: Joi.exist(),
      otherwise: Joi.required(),
      then: Joi.optional().allow('')
    }),
    srciTransactionId: Joi.string()
      .max(100)
      .required(),
    visaSrci: Joi.boolean().optional(),
    xo_visitid: Joi.string()
      .max(100)
      .optional()
  })
  .or('dpaData', 'srciDpaId');

export default InitModel;
